const AVC_DISCONNECT_DIALOG_COPY = {
  title: 'Disconnect Amazon Vendor Central',
  description: 'Vizit will stop syncing this account. Scores and reports we have already calculated stay in place.',
  amazonNote:
    'Amazon has no revoke we can call, so this only clears the token on our side. The authorization stays live on Amazon until someone removes Vizit in Vendor Central, under Manage Your Apps.',
  cancel: 'Cancel',
  confirm: 'Disconnect',
} as const;

export { AVC_DISCONNECT_DIALOG_COPY };
